import {
  NotificationActivityTypes,
  type NotificationPreferenceDomainSelectModel,
  NotificationPreferenceId,
  UserId,
} from '@mntn-dev/domain-types'
import { getRandomItem } from '@mntn-dev/utilities'

import { MockModel } from './mock-model.ts'

export const MockNotificationPreference =
  MockModel<NotificationPreferenceDomainSelectModel>(
    ({
      notificationPreferenceId = NotificationPreferenceId(),
      userId = UserId(),
      activityType = getRandomItem(NotificationActivityTypes),
      enabled = true,
      optOuts = [],
    }) => {
      return {
        notificationPreferenceId,
        userId,
        activityType,
        enabled,
        optOuts,
      } satisfies NotificationPreferenceDomainSelectModel
    }
  )
